import { render, staticRenderFns } from "./SocialMediaCard.vue?vue&type=template&id=f9bbeb48"
import script from "./SocialMediaCard.vue?vue&type=script&lang=js"
export * from "./SocialMediaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports